/* global cURL */
/**
 * Keeps the server session alive while the user is active on the page.
 * Pings at most once per interval; activity within an interval results in one ping at the end of that interval.
 * No activity means no pings, so an idle session still expires normally.
 */
export class KeepAlive {
  #url;
  #interval;
  #lastPing = 0;
  #timeoutId = null;

  /**
   * @param {object} [options]
   * @param {string} [options.url] the URL to ping (default: Merlin's dummy servlet, which resets the session timeout)
   * @param {number} [options.interval] the minimum time between pings in ms (default 5 min; keep well below the
   *                                    session timeout)
   */
  constructor({ url = `${cURL}merlin/dummy`, interval = 5 * 60 * 1000 } = {}) {
    this.#url = url;
    this.#interval = interval;
    this.#lastPing = Date.now(); // the page request itself just refreshed the session
    ['pointerdown', 'keydown', 'change', 'scroll'].forEach(type => {
      document.addEventListener(type, this.#handleActivity, { passive: true });
    });
  }

  #handleActivity = () => {
    if (this.#timeoutId) return; // a trailing ping is already scheduled
    const wait = this.#lastPing + this.#interval - Date.now();
    if (wait <= 0) this.#ping();
    else this.#timeoutId = setTimeout(this.#ping, wait);
  };

  #ping = () => {
    this.#timeoutId = null;
    this.#lastPing = Date.now();
    fetch(this.#url, { cache: 'no-store' })
      .catch(error => console.error('KeepAlive request failed:', error));
  };
}
